import React from 'react'

function Card({ title, description, img, altImg }) {
  return (
    <div
      data-aos="fade-up"
      className="cards-portfolio text-white text-center flex-center flex-column justify-between"
    >
      <div className="img img-60">
        <img src={img} alt={altImg} />
      </div>
      <h2>{title}</h2>
      <p>{description}</p>
    </div>
  )
}

export default Card
